import { useEffect } from "react";

export function useSeo({ title, description, canonical, image } = {}) {
  useEffect(() => {
    const full = title ? `${title} | Buddy Solution` : "Buddy Solution - Premium Digital Solutions Worldwide";
    document.title = full;

    const set = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(k, v.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", full);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:image"]', "content", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical || `https://buddysolution.net${window.location.pathname}`);
  }, [title, description, canonical, image]);
}
